import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import { ServerGroup } from '../model'

export const serverGroupsSelector = createSharedSelector(
  getDataSelector<DataKeys.ServerGroups>(DataKeys.ServerGroups),
  (serverGroups) => {
    return serverGroups.map((serverGroup) => {
      // any model changes go here
      return serverGroup
    })
  },
)

export const serverGroupsByInstanceIdSelector = createSharedSelector(
  getDataSelector<DataKeys.ServerGroups>(DataKeys.ServerGroups),
  (serverGroups) => {
    return serverGroups.reduce((accum, serverGroup) => {
      const forServerGroup = serverGroup?.members?.reduce((acc, member) => {
        return {
          ...acc,
          [member]: serverGroup,
        }
      }, {})
      return {
        ...accum,
        ...forServerGroup,
      }
    }, {})
  },
)

export const allServerGroupsSelector = createSharedSelector(
  getDataSelector<DataKeys.AllServerGroups>(DataKeys.AllServerGroups),
  (serverGroups) => {
    return serverGroups.map((serverGroup) => {
      // any model changes go here
      return serverGroup
    })
  },
)

export const allServerGroupsByInstanceIdSelector = createSharedSelector(
  getDataSelector<DataKeys.AllServerGroups>(DataKeys.AllServerGroups),
  (serverGroups) => {
    const instanceIdToServerGroup: Record<string, ServerGroup> = {}

    for (const serverGroup of serverGroups) {
      if (!serverGroup?.members) continue

      for (const instanceId of serverGroup.members) {
        instanceIdToServerGroup[instanceId] = serverGroup
      }
    }

    return instanceIdToServerGroup
  },
)
